const snailRouter = [
    {
        path: "list-snail",
        name: "snail",
        component: () => import("@/views/admin/snail"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-snail/add",
        name: "addSnail",
        component: () => import("@/views/admin/snail/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-snail/edit/:id",
        name: "editSnail",
        component: () => import("@/views/admin/snail/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
];
export default snailRouter;